"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityStatusReason = exports.IdentityStatus = exports.IdentityType = void 0;
var IdentityType;
(function (IdentityType) {
    IdentityType["BUSINESS_IDENTIFIER"] = "BUSINESS_IDENTIFIER";
    IdentityType["DRIVERS_LICENSE"] = "DRIVERS_LICENSE";
    IdentityType["PASSPORT"] = "PASSPORT";
    IdentityType["PERMANENT_RESIDENT_CARD"] = "PERMANENT_RESIDENT_CARD";
    IdentityType["SSN"] = "SSN";
    IdentityType["STATE_ID_CARD"] = "STATE_ID_CARD";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
var IdentityStatus;
(function (IdentityStatus) {
    IdentityStatus["ACTIVE"] = "ACTIVE";
    IdentityStatus["ARCHIVED"] = "ARCHIVED";
})(IdentityStatus = exports.IdentityStatus || (exports.IdentityStatus = {}));
var IdentityStatusReason;
(function (IdentityStatusReason) {
    IdentityStatusReason["CREATED"] = "CREATED";
    IdentityStatusReason["DEACTIVATED"] = "DEACTIVATED";
})(IdentityStatusReason = exports.IdentityStatusReason || (exports.IdentityStatusReason = {}));
//# sourceMappingURL=types.js.map